import {Injectable} from '@angular/core';

@Injectable()
export class UserAgentService {

  constructor() {
  }

  public isMobile(): boolean {
    if (this.checkUserAgent() !== 'pc') {
      return true;
    }

    return false;
  }

  private checkUserAgent(): string {
    let ua = navigator.userAgent;

    if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      ua = 'sp';
    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      ua = 'tablet';
    } else {
      ua = 'pc';
    }

    return ua;
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/service/utils/user-agent.service.ts